/*
 * Metrics — 5-stat band content for the MetricsBand primitive.
 *
 * Used by:
 *   - Root /home page, between HeroTwo and LogoMarquee.
 *
 * Labels verbatim as supplied (2026-05-27). Update when scale milestones change.
 */

export const HOMEPAGE_METRICS = [
  { value: '350+', label: 'Global brand' },
  { value: '40B+', label: 'Data point processed' },
  { value: '20M+', label: 'Customer case resolved' },
  { value: '35M+', label: 'Customer profiles identified' },
  { value: '4',    label: 'Continents served' },
];
